import React from 'react';
import ShipPurchaseDisplay from './ShipPurchaseDisplay';
import commandShipIcon from '../../assets/ships/command-ship.png';
import haulerShipIcon from '../../assets/ships/hauler-ship.png';
import miningFrigateIcon from '../../assets/ships/mining-frigate.png';
import freighterIcon from '../../assets/ships/freighter.png';
import bargeIcon from '../../assets/ships/barge.png';

export type ShipPurchasePanelProps = {
    ships: Array<{
        type: string;
        name: string;
        description: string;
        specificationDescription?: string;
        specificationsHeader?: string;
        specificationNote?: string;
        cost: number;
        baseStats: { 
            mining: number; 
            cargo: number; 
            speed: number;
            warpSpeed?: number;
            unloadSpeed?: number;
            fleetBonus?: number;
        };
        onPurchase: () => void;
        disabled?: boolean;
        playerOre?: number;
        iconUrl?: string;
    }>;
};

const iconMap: Record<string, string> = {
    'command-ship': commandShipIcon,
    'hauler-ship': haulerShipIcon,
    'mining-frigate': miningFrigateIcon,
    'freighter': freighterIcon,
    'barge': bargeIcon,
};

const ShipPurchasePanel: React.FC<ShipPurchasePanelProps> = ({ ships }) => {
    return (
        <div className="ship-purchase-panel">
            <div className="ship-purchase-list">
                {ships.map((ship) => (                    
                    <ShipPurchaseDisplay
                        key={ship.type}
                        name={ship.name}
                        image={ship.iconUrl || iconMap[ship.type] || ''} // Use iconUrl if available
                        cost={ship.cost}
                        description={ship.description}
                        specificationDescription={ship.specificationDescription}
                        specificationsHeader={ship.specificationsHeader}
                        specificationNote={ship.specificationNote}
                        baseStats={ship.baseStats}
                        onPurchase={ship.onPurchase}
                        disabled={ship.disabled}
                        playerOre={ship.playerOre}
                    />
                ))}
            </div>
        </div>
    );
};

export default ShipPurchasePanel;
